
















import { Guid } from 'guid-typescript'
import mediumZoom from 'medium-zoom'
import Vue from 'vue'
import { Component, Prop, Ref } from 'vue-property-decorator'

@Component
export default class ZoomableImage extends Vue {
  @Ref('imageParent') readonly imageParent!: HTMLImageElement

  @Ref('image') readonly image!: HTMLImageElement

  @Prop() readonly src!: string

  @Prop() readonly alt!: string

  readonly guid: Guid = Guid.create()

  mounted(): void {
    const zoom = mediumZoom(`[data-zoomable='${ this.guid }']`, {
      margin: 24,
      scrollOffset: 0,
    })

    this.imageParent.addEventListener('click', () => {
      zoom.open().then(() => {
        // const target: HTMLElement = document.querySelectorAll(`[class='medium-zoom-image medium-zoom-image--opened'][data-zoomable='${this.guid}']`)[0] as HTMLElement
        // const transform = target.style.transform.slice().replace('translate3d', 'translate').replace(', 0px)', ')')
        // console.log(target)
        // target.style.transform = transform
        // console.log()
      })
    })
  }
}
